export const propuestasItems = [
  {
    image: "/images/carousel/post1.jpg",
    text: "Decidimos plantar bandera en Frías.",
    link: "https://www.instagram.com/reel/DWZBTwojoAU/?igsh=aGdjeDZvZDJqbXN3"
  },
  {
    image: "/images/carousel/post2.jpg",
    text: "Los intereses de la casta política ya no son los mismos que los del pueblo.",
    link: "https://www.instagram.com/reel/DWEfbBpDgBF/?igsh=aHc0cm5naWdwMzR6"
  }
];